import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.762 10.298a1.84 1.84 0 0 0 2.476 0l5.634-5.27c-.265-.62-.907-1.027-1.622-1.028H4.75c-.714.001-1.357.408-1.622 1.029z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.063 11.07c-1.14 1.062-2.986 1.062-4.125 0L3 6.454V16h14V6.455z"
    }, null, -1)
  ])))
}
export default { render: render }